import React from "react"
import {
  Grid, GridItem, Link, Text,
} from "@chakra-ui/react"
import { Website } from "sharedTypes"
import { BuilderBlock } from "sharedTypes/builder"
import BlockContent from "components/Builder/BlockContent"
import SidebarBlock from "./SidebarBlock"

const EventDetail = ({
  website: {
    dateEnabled,
    dateHeader,
    dateLine1,
    dateLine2,
    locationEnabled,
    locationVenue,
    locationLine1,
    locationLine2,
    locationLine3,
    links,
    linksEnabled,
    rsvpButtonColor,
  },
  websiteBlocks = [],
}: {
  website: Website
  websiteBlocks?: BuilderBlock[]
}) => {
  const showDate = dateEnabled && (dateHeader || dateLine1 || dateLine2)
  const showLocation = locationEnabled
    && (locationVenue || locationLine1 || locationLine2 || locationLine3)
  const showLinks = linksEnabled && links && links.length > 0
  const showSidebar = showDate || showLocation || showLinks

  return (
    <Grid templateColumns="repeat(7, 1fr)" gap={6}>
      <GridItem
        colSpan={{ base: 7, lg: showSidebar ? 5 : 7 }}
        order={{ base: 2, lg: 1 }}
      >
        {websiteBlocks.map((block, index) => (
          <BlockContent key={index} block={block} hasPadding />
        ))}
      </GridItem>
      {showSidebar && (
      <GridItem
        colSpan={{ base: 7, lg: 2 }}
        minW="325px"
        order={{ base: 1, lg: 2 }}
      >
        {showDate && (
        <SidebarBlock
          title={dateHeader}
          iconName="event-date"
          iconColor={rsvpButtonColor}
        >
          <Text>{dateLine1}</Text>
          <Text>{dateLine2}</Text>
        </SidebarBlock>
        )}
        {showLocation && (
          <SidebarBlock
            title={locationVenue}
            iconName="map-outline"
            iconColor={rsvpButtonColor}
          >
            <Text>{locationLine1}</Text>
            <Text>{locationLine2}</Text>
            <Text>{locationLine3}</Text>
          </SidebarBlock>
        )}
        {showLinks && (
          <SidebarBlock
            title="Links"
            iconName="link-chain"
            iconColor={rsvpButtonColor}
          >
            {links.map((link, index) => (
              <Link
                href={link}
                key={index}
                display="block"
                isExternal
                color={rsvpButtonColor}
              >
                {link}
              </Link>
            ))}
          </SidebarBlock>
        )}
      </GridItem>
      )}
    </Grid>
  )
}

export default EventDetail
